/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Credit_Note_Not_OpenInputs */

const en_error_credit_note_not_open = /** @type {(inputs: Error_Credit_Note_Not_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The credit note cannot change now: Tomorrow has already received it. Reload the page to see where it is.`)
};

/**
* | output |
* | --- |
* | "The credit note cannot change now: Tomorrow has already received it. Reload the page to see where it is." |
*
* @param {Error_Credit_Note_Not_OpenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_credit_note_not_open = /** @type {((inputs?: Error_Credit_Note_Not_OpenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Credit_Note_Not_OpenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_credit_note_not_open(inputs)
});